<template>
    <div class="features-section">
        <div class="container">
            <div class="section-header" data-aos="fade-up">
                <span class="section-tag">Was wir bieten</span>
                <h2>Unsere Leistungen</h2>
            </div>
            <div class="features-grid">
                <router-link to="/services/webentwicklung" class="feature-card" data-aos="fade-up" data-aos-delay="0">
                    <div class="feature-number">01</div>
                    <div class="feature-icon">
                        <i class='bx bx-laptop'></i>
                    </div>
                    <h3>Webentwicklung</h3>
                    <p>Von einfachen Landingpages bis zu komplexen Webanwendungen. Responsive Design und moderne Technologien für Ihren Erfolg.</p>
                    <div class="feature-arrow">
                        <i class='bx bx-arrow-back bx-rotate-180'></i>
                    </div>
                </router-link>

                <router-link to="/services/seo" class="feature-card" data-aos="fade-up" data-aos-delay="100">
                    <div class="feature-number">02</div>
                    <div class="feature-icon">
                        <i class='bx bx-search-alt'></i>
                    </div>
                    <h3>SEO-Optimierung</h3>
                    <p>Analyse und Verbesserung Ihrer Suchmaschinenplatzierung. Mehr Sichtbarkeit für Ihr Unternehmen im Web.</p>
                    <div class="feature-arrow">
                        <i class='bx bx-arrow-back bx-rotate-180'></i>
                    </div>
                </router-link>

                <router-link to="/services/betreuung" class="feature-card" data-aos="fade-up" data-aos-delay="200">
                    <div class="feature-number">03</div>
                    <div class="feature-icon">
                        <i class='bx bx-wrench'></i>
                    </div>
                    <h3>Betreuung & Wartung</h3>
                    <p>Zuverlässige Unterstützung auch nach Projektabschluss. Updates, Backups und technischer Support für Ihre Webpräsenz.</p>
                    <div class="feature-arrow">
                        <i class='bx bx-arrow-back bx-rotate-180'></i>
                    </div>
                </router-link>

                <router-link to="/services/it-beratung" class="feature-card" data-aos="fade-up" data-aos-delay="300">
                    <div class="feature-number">04</div>
                    <div class="feature-icon">
                        <i class='bx bx-conversation'></i>
                    </div>
                    <h3>IT-Beratung</h3>
                    <p>Strategische Beratung für Ihre digitalen Projekte. Wir analysieren Anforderungen und finden die passende Lösung.</p>
                    <div class="feature-arrow">
                        <i class='bx bx-arrow-back bx-rotate-180'></i>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Features'
}
</script>